import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';
import { ILegalClientFullObject } from '../Interfaces/ILegalClient';
import { useGetLegalClientTypes } from '../hooks/data';
import { LoadingSpinner } from '../core/LoadingSpinner';

type IProps = {
  formValues: ILegalClientFullObject;
  setFormValues: Dispatch<SetStateAction<ILegalClientFullObject>>;
  onlyJuristic?: boolean; //nur juristrische
};

export const LegalClientTypeForm = ({
  formValues,
  setFormValues,
  onlyJuristic,
}: IProps) => {
  const { legalClientTypes, isLoadingLegalClientTypes } =
    useGetLegalClientTypes();

  if (!legalClientTypes && isLoadingLegalClientTypes) {
    return <LoadingSpinner />;
  }

  if (!legalClientTypes) {
    return null;
  }

  return (
    <FormControl fullWidth size='small'>
      <InputLabel id='legal-client-type-label'>Typ</InputLabel>
      <Select
        labelId='legal-client-type-label'
        label='Typ'
        value={formValues.idLegalClientType}
        disabled={onlyJuristic}
        onChange={event => {
          const newTypeId = Number(event.target.value);
          setFormValues((prev: ILegalClientFullObject) => ({
            ...prev,
            idLegalClientType: newTypeId,

            LegalClientType: legalClientTypes.find(
              type => type.idLegalClientType === newTypeId
            )!.LegalClientType,
            FirstName: '',
            LastName: '',
            idGender: 4,
            idBusinessForm:
              newTypeId === 1
                ? 1
                : prev.idBusinessForm === 1
                  ? 2
                  : prev.idBusinessForm,
          }));
        }}
      >
        {legalClientTypes.map((type, i) => (
          <MenuItem key={i} value={type.idLegalClientType}>
            {type.LegalClientType}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
